<div class="layout-shell">
  @if (isCheckingBackend) {
    <section class="fullscreen-state" aria-live="polite">
      <div class="spinner" aria-hidden="true"></div>
      <p>{{ 'common.loading' | translate }}</p>
    </section>
  } @else if (isBackendReachable) {
      <!-- <app-header></app-header> -->

    <main class="layout-content">
      <router-outlet></router-outlet>
    </main>

      <!-- <app-footer></app-footer> -->
  } @else {
    <app-under-construction></app-under-construction>
  }
</div>
